import { render, staticRenderFns } from "./MySummaryTest.vue?vue&type=template&id=24da9d07&scoped=true"
import script from "./MySummaryTest.vue?vue&type=script&lang=js"
export * from "./MySummaryTest.vue?vue&type=script&lang=js"
import style0 from "./MySummaryTest.vue?vue&type=style&index=0&id=24da9d07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24da9d07",
  null
  
)

export default component.exports